export default class AttachmentUploadStatusNotFoundError extends Error {

}